import React, { component } from 'react'

export const CustomerSettings = () => {
    return (
        <div>Customer Settings</div>
    )
}